import WDHRichText from '../../../../wdh-feature/wdh-rich-text/src/js/wdh-rich-text';
import WDHRichTextOverlay from '../../../../wdh-feature/wdh-rich-text/src/js/variations/overlay';
var richText = new WDHRichText();
richText.registerVariation(new WDHRichTextOverlay());
richText.run();